import React,{useState} from "react";
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";
import { Collapse, CardBody, Card } from 'reactstrap';
import SubscribeCard from "react-subscribe-card";


const Footer = (props) => {
                                   const [collapse, setCollapse] = useState(false);
                                   const [collapse1, setCollapse1] = useState(false);
                                   const [collapse2, setCollapse2] = useState(false);
                                   const [collapse3, setCollapse3] = useState(false);
                                   const [status, setStatus] = useState('Closed');
                                 
                                   const onEntering = () => setStatus('Opening...');
                                 
                                   const onEntered = () => setStatus('Opened');
                                 
                                   const onExiting = () => setStatus('Closing...');
                             
                                   const onExited = () => setStatus('Closed');
                                 
                                   const toggle = () => setCollapse(!collapse);
                                  const toggle1 = () => setCollapse1(!collapse1);
                                  const toggle2 = () => setCollapse2(!collapse2);
                                  const toggle3 = () => setCollapse3(!collapse3);
                                  
const mailchimpURL = `https://tech.us2.list-manage.com/subscribe/post?u=ed37e0cafc891c9b2d528b4c2&amp;id=c1504669fa`;
const title = 'Join Our NewsLetter';
const outerCardStyle = `
      padding: 0;
      box-shadow: 0px 5px 35px 0px rgba(50, 50, 93, 0.17);
    `;
const subContainerStyle = `
      box-shadow: 0 2px 5px -1px rgba(50,50,93,.25), 0 1px 3px -1px rgba(0,0,0,.3);
      align-items: center;
    `;
const subInputStyle = `
      border-width: 0;
      margin: 0;
    `;
const subButtonStyle = `
      border-radius: 0;
      flex-grow: 1;
      background-color: #fdfdfd;
      color: #000000;
    `;
 


  return (
    <MDBFooter  className="footer-module--site-footer--2GvNu site-footer page-footer font-small lighten-5 pt-0">
      <div style={{ backgroundColor: "black",color:"white"}}>
        <MDBContainer>
          <MDBRow className="py-4 d-flex align-items-center">
            <MDBCol md="6" lg="5" className="text-center text-md-left mb-4 mb-md-0">
              
            <h6 className="mb-0 white-text">
            <SubscribeCard
            title
            description            
            mailchimpURL={mailchimpURL}
            outerCardStyle={outerCardStyle}
            subContainerStyle={subContainerStyle}
            subInputStyle={subInputStyle}
            subButtonStyle={subButtonStyle}
          />
              </h6>
            </MDBCol>
      
            <MDBCol  md="6" lg="7" className="text-center text-white text-md-right"> 
            <a  href="https://github.com/blogue-tech" target="_blank">
                <i style={{color:"white !important"}}className="fa fa-github fa-lg  mr-lg-4"> </i>
              </a>
              <a  href="https://twitter.com/blogue_tech" target="_blank">
                <i style={{color:"white !important"}}className="fa fa-twitter fa-lg  mr-lg-4"> </i>
              </a>
              <a  href="mailto:theblogueteam.com" target="_blank">
                <i style={{color:"white !important"}}className="fa fa-google fa-lg  mr-lg-4"> </i>
              </a>
              <a  href="https://www.instagram.com/blogue.tech" target="_blank">
                <i style={{color:"white !important"}} className="fa fa-instagram fa-lg  mr-lg-4"> </i>
              </a>
              <a  href="https://www.facebook.com/blogue.tech" target="_blank">
                <i style={{color:"white !important"}} className="fa fa-facebook fa-lg  mr-lg-4"> </i>
              </a>
              <b><a color="primary" onClick={toggle2} style={{ color:"white !important",marginBottom: '1rem',cursor: "pointer"}}>QR</a></b>
      <Collapse
        isOpen={collapse2}
        onEntering={onEntering}
        onEntered={onEntered}
        onExiting={onExiting}
        onExited={onExited}
      >
        <Card>
          <CardBody style={{color:"black"}}>
          <p>
          <img src="https://github.com/sujanchhetri/TwitterFeedScraping/blob/master/theblogueteaminsta.png?raw=true" height="200px" width="200px"/>
          ..............................
          <img src="https://github.com/sujanchhetri/TwitterFeedScraping/blob/master/theblogueteamtweet.jpg?raw=true" height="200px" width="200px"/>
            </p>
          </CardBody>
        </Card>
      </Collapse>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      <MDBContainer className="mt-5 mb-4 text-center text-md-left">
        <MDBRow className="mt-3">
        <MDBCol md="3" lg="4" xl="3" className="mb-4 dark-grey-text">
            <h6 className="text-uppercase font-weight-bold">
              <strong>the blogue team</strong>
            </h6>
            <hr className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{ width: "60px" }} />
            <p>
              Welcome to our world,Your world;where writing happens..
            </p>
            Support us:<br/>
            <b><a color="primary" onClick={toggle3} style={{ color:"white !important",marginBottom: '1rem',cursor: "pointer"}}>Scan</a></b>
<Collapse
        isOpen={collapse3}
        onEntering={onEntering}
        onEntered={onEntered}
        onExiting={onExiting}
        onExited={onExited}
      >
        <Card>
          <CardBody style={{color:"black"}}>
          <p>
          <img src="https://github.com/sujanchhetri/TwitterFeedScraping/blob/master/paypal.png?raw=true" height="200px" width="200px"/>
          </p>
          </CardBody>
        </Card>
      </Collapse>
            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
<input type="hidden" name="cmd" value="_donations" />
<input type="hidden" name="business" value="nodeguydeno@gmail.com" />
<input type="hidden" name="item_name" value="blogue" />
<input type="hidden" name="currency_code" value="USD" />
<input type="image" src="https://www.paypalobjects.com/en_AU/i/btn/btn_donateCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
<img alt="" border="0" src="https://www.paypal.com/en_AU/i/scr/pixel.gif" width="1" height="1" />
</form>

      <a href="https://www.buymeacoffee.com/sujanchhetri"><img src="https://img.buymeacoffee.com/button-api/?text=Buy us a book&emoji=📖&slug=sujanchhetri&button_colour=BD5FFF&font_colour=ffffff&font_family=Cookie&outline_colour=000000&coffee_colour=FFDD00"/></a>
          </MDBCol>
          <MDBCol md="6" lg="2" xl="3" className="mb-4 dark-grey-text">
            
<a style={{ cursor: "pointer" }} href="https://blogue.tech/Info" ><i className="text-light">
<h6 className="text-uppercase font-weight-bold">
<strong>About us:</strong>
</h6></i></a>
Blogue is a writing platform where all the writers or non-writers are welcome.
We Belive in sharing knowlege in the form of words.
          </MDBCol>
          <MDBCol md="4" lg="3" xl="3" className="mb-4 dark-grey-text">
            <h6 className="text-uppercase font-weight-bold">
              <strong>Contact</strong>
            </h6>
            <hr className="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{ width: "60px" }} />
            <p>
              <i className="fa fa-home mr-3" /> nodeguydeno@gmail.com
            </p>
            <p>
              <i className="fa fa-envelope mr-3" /> theblogueteam@gmail.com
            </p>
          </MDBCol>
          <MDBCol md="6" lg="5" xl="3" className="mb-4 dark-grey-text text-md-right">
          <img src="https://blogue.tech/static/images/logo.gif" width="200" height="200"/>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
        
      <MDBContainer>
        <div>
      <a color="primary" onClick={toggle} style={{color:"white !important",textAlign:'center', marginBottom: '1rem',cursor: "pointer" }}>&copy; {new Date().getFullYear()} Copyright:{" "}theblogueteam</a>
<a style={{ cursor: "pointer"}} href="https://blogue.tech/Info"><i className="text-light">{" "}About</i></a>
<a style={{ cursor: "pointer"}} href="https://blogue.tech/Info"><i className="text-light">{" "}Terms & Conditions</i></a>
<a style={{ cursor: "pointer"}} href="https://blogue.tech/Info"><i className="text-light">{" "}Privacy Policy</i></a>
      <Collapse
        isOpen={collapse}
        onEntering={onEntering}
        onEntered={onEntered}
        onExiting={onExiting}
        onExited={onExited}
      >
        <Card>
          <CardBody style={{color:"black"}}>
          MIT License

Copyright (c) 2020 Blogue 

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
          </CardBody>
        </Card>
      </Collapse>
    </div>
    </MDBContainer>
      </div>
    </MDBFooter>
  );
}


export default Footer;
